import { isNullOrUndefined } from "../../utils/utils";
import { IStoredTranscription, TranscriptionStorageType } from "../interfaces/IStoredTranscription";
import { ITranscription } from "../interfaces/ITranscriptionManager";
import { SpeakerNameManager } from "../manager/speakerNameManager/SpeakerNameManager";


export class TranscriptionData {
    private storedTranscription: IStoredTranscription;
    private speakerNameManager: SpeakerNameManager;

    constructor(storedTranscription: IStoredTranscription) {
        if (isNullOrUndefined(storedTranscription.descriptor) || isNullOrUndefined(storedTranscription.descriptor.audioOneDriveItem) ||
            isNullOrUndefined(storedTranscription.descriptor.transcription)) {
            throw 'TranscriptionObject can not be created with Invalid IStoredTranscription';
        }
        this.storedTranscription = storedTranscription;
        this.speakerNameManager = new SpeakerNameManager(this.storedTranscription.descriptor.transcription);
    }

    public GetTranscription(): ITranscription {
        return this.storedTranscription.descriptor.transcription;
    }

    public updateStorageType(storageType: TranscriptionStorageType) {
      this.storedTranscription.storageType = storageType;
    }

    public GetSpeakerNameManager(): SpeakerNameManager {
        return this.speakerNameManager;
    }

    public GetStoredTranscription(): IStoredTranscription {
        return this.storedTranscription;
    }
}